module.exports = __webpack_public_path__ + "img/culture3.fd80a9e2.jpg";